module.exports = "<app-header></app-header> <div class=content-wrapper> <div ui-view class=content-view></div> </div>";